import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  position: absolute;
  left: calc(((100vw - 720px) / 2) - (250px + 20px));
  width: 250px;
  z-index: 10;
`
